import QueryString from "qs";
import { useEffect, useReducer, useState } from "react";
import { Edit } from "react-feather";
import { toast } from "react-hot-toast";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Col, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import FormInput from "../../components/FormInput";
import FormSelect from "../../components/FormSelect";
import { CityData, getCities } from "../../services/city.service";
import { getStates } from "../../services/state.service";

const initialState = {
  data: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 10,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

function Cities() {
  const [filterData, setFilterData] = useState({
    search: "",
    state: "",
  });
  const [state, setState] = useState("");
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };

  useEffect(() => {
    const { page, state } = query;
    getCities({ page, search: filterData.search, state })
      .then((response: any) => {
        setData(response.data);
      })
      .catch(() => {
        toast.error("Failed to fetch cities");
      });
  }, [location.search]);

  const columns = [
    {
      selector: (row: any) => row.serialNumber,
      name: "S.No.",
      sortable: false,
      maxWidth: "70px",
      minWidth: "70px",
    },
    {
      selector: (row: CityData) => row.name,
      name: "City Name",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => row.state?.name || "N/A",
      name: "State",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => (
        <>
          <Link
            className='me-1'
            to={`edit/${row.id}?${QueryString.stringify({
              redirect: location.pathname + location.search,
            })}`}
          >
            <Edit size={15} />
          </Link>
        </>
      ),
      name: "Actions",
      sortable: false,
      center: true,
      maxWidth: "90px",
      minWidth: "90px",
    },
  ];

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };
    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });

    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };

  const handleClearFilter = () => {
    setState("");
    setFilterData({ search: "", state: "" });
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>City Master</h1>
        </Col>
        <Col sm='auto'>
          <div className='justify-content-between'>
            <Link
              to={`/cities/add?${QueryString.stringify({
                redirect: location.pathname + location.search,
              })}`}
              className='btn btn-sm btn-primary my-1 text-white'
            >
              Add New
            </Link>
          </div>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-auto'>
        <Card className='h-100 p-3 w-100'>
          <div className='d-flex flex-column h-100 rounded-0'>
            <DataGrid
              columns={columns}
              data={data}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              subHeaderComponent={
                <Row>
                  <Col md={3}>
                    <FormInput
                      name='search'
                      label='City Name'
                      placeholder='Search by name'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.search}
                    />
                  </Col>
                  <Col md={3}>
                    <FormSelect
                      id='state'
                      name='state'
                      label='State'
                      isAsync
                      isClearable
                      getOptions={getStates}
                      value={state}
                      onChange={(name: any, value: any) => {
                        setState(value);
                        setFilterData({
                          ...filterData,
                          [name]: value?.id,
                        });
                      }}
                    />
                  </Col>

                  <Col md={6} className='mt-1'>
                    <div className='mt-4'>
                      <Button
                        color='primary'
                        size='sm'
                        className='me-2'
                        onClick={() => handleFilter()}
                      >
                        Filter
                      </Button>
                      <Button
                        color='danger'
                        size='sm'
                        className='me-2'
                        onClick={() => handleClearFilter()}
                      >
                        Clear
                      </Button>
                    </div>
                  </Col>
                </Row>
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}

export default Cities;
